module.exports = __webpack_public_path__ + "img/manufacture@2x.b10d459.jpg";